import React, { ReactNode } from "react";

interface Props {
  index: number;
  children: ReactNode;
  currentIndex: number;
}

export const TabPanel = ({ children, index, currentIndex }: Props) =>
  currentIndex === index ? (
    <div id={`tabPanel-${index}`} role="tabpanel" aria-labelledby={`tab-${index}`}>
      {children}
    </div>
  ) : null;
